import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RecoverPasswordComponent } from './pages/recover-password/recover-password.component';
import { SigninComponent } from './pages/signin/signin.component';
import { AuthAccountComponent } from './pages/signup/auth-account/auth-account.component';
import { AuthGuard } from './guards/auth.guard';
import { ConfirmEmailComponent } from './pages/confirm-email/confirm-email.component';
import { RedirectOnboardingComponent } from './pages/redirect-onboarding/redirect-onboarding.component';

const routes: Routes = [
  {
    path: 'register',
    component: AuthAccountComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'register/:referedBy',
    component: AuthAccountComponent,
    canActivate: [AuthGuard],
  },
  { path: 'confirm_email', component: ConfirmEmailComponent },
  { path: 'signin', component: SigninComponent, canActivate: [AuthGuard] },
  { path: 'recover_password', component: RecoverPasswordComponent },
  { path: 'redirect', component: RedirectOnboardingComponent },
  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
